import { createGlobalStyle } from 'styled-components/macro';

export const CustomShadows = createGlobalStyle`
  :root {
    --shadow-color:  0deg 0% 65%;
    --app-height: 100%;
  }
`;
